import React from 'react';
import { render } from 'react-dom';

import ErrorMessage from './components/ErrorMessage';
import TestScoreHistogram from './components/TestScoreHistogram';

function renderTestScoreHistogram(container, scores = [], toFixedNum = 2) {
  if (scores.length < 1) {
    render(
      <ErrorMessage message="受験者がいないため、Chartを表示できません。" />,
      container,
    );
  } else {
    render(
      <TestScoreHistogram scores={scores} toFixedNum={toFixedNum} />,
      container,
    );
  }
}

export default renderTestScoreHistogram;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/utils/renderTestScoreHistogram.js